import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

export interface KBCategory {
  id: number;
  name: string;
  slug: string;
  sortOrder: number;
  articleCount: number;
}

export interface KBArticleSummary {
  id: number;
  title: string;
  slug: string;
  documentType: string;
  sortOrder: number;
  isPublished: boolean;
  modifiedDate: string;
  modifiedBy: number;
}

export interface KBArticle {
  id: number;
  categoryId: number;
  categoryName: string;
  categorySlug: string;
  title: string;
  slug: string;
  content: string;
  documentType: string;
  sortOrder: number;
  isPublished: boolean;
  createdDate: string;
  createdBy: number;
  modifiedDate: string;
  modifiedBy: number;
}

export interface KBSearchResult {
  id: number;
  title: string;
  slug: string;
  documentType: string;
  categoryId: number;
  categoryName: string;
  categorySlug: string;
  modifiedDate: string;
  modifiedBy: number;
  snippet: string;
  relevance: number;
}

export interface KBRevision {
  id: number;
  articleId: number;
  title: string;
  content: string;
  changeNote: string;
  revisionNumber: number;
  createdDate: string;
  createdBy: number;
}

@Injectable({ providedIn: 'root' })
export class KnowledgeBaseService {
  private base = `${environment.baseURl}/api/knowledgebase`;

  constructor(private http: HttpClient) {}

  getCategories() {
    return this.http.get<KBCategory[]>(`${this.base}/categories`);
  }

  getArticlesByCategory(categoryId: number) {
    return this.http.get<KBArticleSummary[]>(`${this.base}/categories/${categoryId}/articles`);
  }

  getArticleById(id: number) {
    return this.http.get<KBArticle>(`${this.base}/articles/${id}`);
  }

  getArticleBySlug(slug: string) {
    return this.http.get<KBArticle>(`${this.base}/articles/by-slug/${slug}`);
  }

  search(query: string) {
    return this.http.get<KBSearchResult[]>(`${this.base}/articles/search`, { params: { q: query } });
  }

  saveArticle(article: KBArticle, changeNote: string) {
    const body = { article, changeNote };
    if (article.id) {
      return this.http.put<KBArticle>(`${this.base}/articles/${article.id}`, body);
    }
    return this.http.post<KBArticle>(`${this.base}/articles`, body);
  }

  getRevisions(articleId: number) {
    return this.http.get<KBRevision[]>(`${this.base}/articles/${articleId}/revisions`);
  }

  getRevision(revisionId: number) {
    return this.http.get<KBRevision>(`${this.base}/revisions/${revisionId}`);
  }
}
